import { useEffect } from "react";

import { App } from "antd";

import { setStaticAntd } from "@/utils/antdStatic";

// Captures the context-aware antd instances into module-level holders so
// non-component code can use them. Must be rendered inside antd's <App>.
const AntdStaticBridge = (): null => {
  const staticApi = App.useApp();

  useEffect(() => {
    setStaticAntd(staticApi);
  }, [staticApi]);

  return null;
};

export default AntdStaticBridge;
